import React, {Component} from 'react';
import {PageLeftItem} from "../../../model/page";
import {LEFT_ITEMS} from "../../../config/components";
import "./page_left_item_component.scss";

interface PageLeftItemComponentProps {
    item: PageLeftItem;
    layoutColumns: number;
}

class PageLeftItemComponent extends Component<PageLeftItemComponentProps> {

    render() {
        let item = this.props.item;

        try {
            let TemplateLeftItem = LEFT_ITEMS.get(item.type);
            if (!TemplateLeftItem) return null;

            let dataProps = {};

            if (!item.data) {
                dataProps = { data: { empty: true } };
            }

            if (item.dataObj) {
                dataProps = { data: item.dataObj };
            }

            return <TemplateLeftItem key={"left-item-" + item.type}
                                      layoutColumns={this.props.layoutColumns}
                                      url={item.data} {...dataProps} data-aos="fade-up"/>;
        } catch (e) {
            console.warn("WARNING: Uncaught exception in left item " + item.type, e);
            return null;
        }
    }
}

export default PageLeftItemComponent;
